import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserSubscription, UserSubscriptionType, UserSubscriptionCategory} from "../../../user/user-subscription";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import {User} from "../../../user/user";
import {IPlanDescriptionInstance} from "../../../user/plan-description/plan-description";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {combineLatest, Subscription} from "rxjs";
import * as fromStore from '../../../store';
import boosterAndAiFeatures from './booster-and-ai_features.json';
import { GoogleAnalyticsService } from '../../../shared/services/google-analytics/google-analytics.service';


@Component({
    selector: 'db-plan-label-booster',
    templateUrl: './db-plan-label-booster.component.html',
    styleUrls: ['./db-plan-label-booster.component.scss'],
    standalone: false
})
export class DbPlanLabelBoosterComponent implements OnInit, OnDestroy {

  @Input() _trialDeleteDay: any;
  @Input() trialDeleteDay: any;
  @Input() userSubscriptionStorage: number;
  @Input() userSubscriptionVisits: number;
  @Input() booster: boolean;
  @Input() user: User;

  public userSubscription: UserSubscription;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public UserSubscriptionType: any = UserSubscriptionType;
  public planDescriptionInstance: IPlanDescriptionInstance;
  public _pluginTitle: any;
  private subscriptions: Subscription[];
  public planFeatures: string[];
  public isExpired: boolean;
  public globalIsExpired: boolean;


  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.loadData();
    this.planFeatures = this.userSubscription.boosterProClient ? boosterAndAiFeatures['booster_pro_features'] :  boosterAndAiFeatures['booster_free_features'] ;
    this.addEventHandlers();
    if (this.userSubscription && this.userSubscription.type === this.UserSubscriptionType.ONE_PRODUCT) {
      this.planDescriptionInstance = this.userSubscription ? this.userSubscription.plan.description.getFeatures(this.userSubscription.productSlug) : null;
    }
  }

  public loadData(updateCache: boolean = false): void {
    if ( updateCache ) {
      this._store.dispatch(new fromStore.UpdateUserSubscription());
    }
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
        ))
      )
      .subscribe(( [user, userSubscription]) => {
        this.userSubscription = userSubscription;

        if (this.userSubscription && this.userSubscription.boosterProClient) {
          this.isExpired = this.userSubscription && ([this.userSubscriptionStatus.canceled, this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.userSubscription.status) || this.userSubscription.isExpired);
        }
        this.globalIsExpired = this.userSubscription && ([this.userSubscriptionStatus.canceled, this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.userSubscription.status) || this.userSubscription.isExpired);
      });
  }

  private addEventHandlers(): void {
    this.subscriptions = [];

    this.subscriptions.push(
      this._store.select(fromStore.getTenWebProductsLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          first()
        )
        .subscribe(() => {
          this._store.select(fromStore.getTenWebProducts)
          .pipe(first())
            .subscribe((products: any[]) => {
              this._pluginTitle = this.userSubscription && this.userSubscription.productSlug ? (products.find((product) => product.slug === this.userSubscription.productSlug)).title : '';
            });
        })
    );
  }

   public sendEvent(label) {
     const analyticsData = {
       eventCategory: 'Dashboard Action',
       eventAction: 'Upgrade button click',
       eventLabel: label
     };
     this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
   }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.subscriptions = null;
  }
}
